var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "160 -775 640 630",
    width: 640,
    height: 630,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.09-675.38q-16.63 0-28.36 11.64T260-635.48q0 16.63 11.64 28.36 11.64 11.74 28.27 11.74t28.36-11.64Q340-618.67 340-635.29q0-16.63-11.64-28.36t-28.27-11.73Zm0 350.76q-16.63 0-28.36 11.64Q260-301.33 260-284.71q0 16.63 11.64 28.36t28.27 11.73q16.63 0 28.36-11.64T340-284.52q0-16.63-11.64-28.36-11.64-11.74-28.27-11.74ZM190.77-775.39h578.46q13.08 0 21.92 8.8 8.85 8.79 8.85 21.78v214.04q0 15.46-8.85 25.42-8.84 9.97-21.92 9.97H190.77q-13.08 0-21.92-9.97-8.85-9.96-8.85-25.42v-214.04q0-12.99 8.85-21.78 8.84-8.8 21.92-8.8Zm9.23 40.01v200h560v-200H200Zm-9.23 310.76h576.92q14.69 0 23.5 9.74 8.81 9.73 8.81 24.11v209.23q0 17-8.81 26.96-8.81 9.97-23.5 9.97H192.31q-14.69 0-23.5-9.97-8.81-9.96-8.81-26.96v-209.23q0-14.38 8.04-24.11 8.04-9.74 22.73-9.74Zm9.23 40v200h560v-200H200Zm0-350.76v200-200Zm0 350.76v200-200Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.d33ccacff4d3279f882125d99fb4ed13.svg";
export { ForwardRef as ReactComponent };